import styled from "styled-components";
import { Backdrop } from "@material-ui/core";

export const StyledBackdrop = styled(Backdrop)`
    z-index: ${({ theme }) => theme.zIndex.modal + 2};
    color: white;
`;
